export const default_dfp_config = {
  "id": "21719097930",
  "refresh_timeout": -1,
  "options": {
    "default_floor": 0,
    "lazy": false
  },
  "pages": [
    {
      "url": [],
      "name": "__ALL__",
      "desktop": {
        "ad_unit_defaults": {
          "sizes": [
            "fluid",
            [
              970,
              250
            ],
            [
              970,
              90
            ],
            [
              728,
              90
            ]
          ]
        },
        "placements": {
          "outstream": {
            "ad_units": [
              {
                "name": "EFE_Outstream",
                "sizes": [
                  [
                    1,
                    1
                  ]
                ]
              }
            ]
          },
          "aside": {
            "ad_units": [
              {
                "name": "efe_topics_160",
                "sizes": [
                  "fluid",
                  [
                    160,
                    600
                  ],
                  [
                    300,
                    600
                  ],
                  [
                    250,
                    250
                  ],
                  [
                    336,
                    280
                  ],
                  [
                    300,
                    250
                  ],
                  [
                    320,
                    100
                  ],
                  [
                    320,
                    50
                  ]
                ]
              }
            ]
          },
          "top": {
            "ad_units": [
              {
                "name": "efe_hp_728"
              }
            ]
          },
          "center-rec": {
            "ad_units": [
              {
                "name": "efe_300_mid",
                "sizes": [
                  "fluid",
                  [
                    336,
                    280
                  ],
                  [
                    250,
                    250
                  ],
                  [
                    300,
                    250
                  ]
                ]
              }
            ]
          },
          "center": {
            "ad_units": [
              {
                "name": "efe_topics_mid_728_1"
              },
              {
                "name": "efe_topics_mid_728_2"
              },
              {
                "name": "efe_topics_mid_728_3"
              }
            ]
          },
          "footer": {
            "ad_units": [
              {
                "name": "efe_topics_bottom_728"
              }
            ]
          }
        }
      },
      "mobile": {
        "ad_unit_defaults": {
          "sizes": [
            [
              728,
              90
            ],
            [
              250,
              250
            ],
            [
              336,
              280
            ],
            [
              300,
              250
            ],
            [
              320,
              100
            ],
            [
              320,
              50
            ],
            "fluid"
          ]
        },
        "placements": {
          "top": {
            "ad_units": [
              {
                "sizes": [
                  [
                    728,
                    90
                  ],
                  [
                    320,
                    100
                  ],
                  [
                    320,
                    50
                  ]
                ],
                "name": "efe_hp_728"
              }
            ]
          },
          "center": {
            "ad_units": [
              {
                "name": "efe_topics_mid_728_1"
              },
              {
                "name": "efe_topics_mid_728_2"
              },
              {
                "name": "efe_topics_mid_728_3"
              }
            ]
          },
          "footer": {
            "ad_units": [
              {
                "sizes": [
                  [
                    728,
                    90
                  ],
                  [
                    320,
                    50
                  ]
                ],
                "name": "efe_topics_bottom_728"
              }
            ]
          }
        }
      }
    },
    {
      "url": [
        "^/viewpdf.html"
      ],
      "urlRegex": true,
      "name": "PDFViewer",
      "desktop": {
        "ad_unit_defaults": {
          "sizes": [
            "fluid",
            [
              970,
              250
            ],
            [
              970,
              90
            ],
            [
              728,
              90
            ]
          ]
        },
        "placements": {
          "outstream": {
            "ad_units": [
              {
                "name": "EFE_Outstream",
                "sizes": [
                  [
                    1,
                    1
                  ]
                ]
              }
            ]
          },
          "right-aside": {
            "ad_units": [
              {
                "name": "EFE_Right_Sticky",
                "sizes": [
                  "fluid",
                  [
                    160,
                    600
                  ],
                  [
                    300,
                    600
                  ],
                  [
                    250,
                    250
                  ],
                  [
                    336,
                    280
                  ],
                  [
                    300,
                    250
                  ],
                  [
                    320,
                    100
                  ],
                  [
                    320,
                    50
                  ]
                ]
              }
            ]
          },
          "top": {
            "ad_units": [
              {
                "name": "EFE_PDF_Top"
              }
            ]
          },
          "below-pdf": {
            "ad_units": [
              {
                "name": "EFE_PDF_Bottom"
              }
            ]
          },
          "footer": {
            "ad_units": [
              {
                "name": "efe_topics_bottom_728"
              }
            ]
          }
        }
      },
      "mobile": {
        "ad_unit_defaults": {
          "sizes": [
            [
              728,
              90
            ],
            [
              250,
              250
            ],
            [
              336,
              280
            ],
            [
              300,
              250
            ],
            [
              320,
              100
            ],
            [
              320,
              50
            ],
            "fluid"
          ]
        },
        "placements": {
          "top": {
            "ad_units": [
              {
                "sizes": [
                  [
                    728,
                    90
                  ],
                  [
                    320,
                    100
                  ],
                  [
                    320,
                    50
                  ]
                ],
                "name": "EFE_PDF_Top"
              }
            ]
          },
          "footer": {
            "ad_units": [
              {
                "sizes": [
                  [
                    728,
                    90
                  ],
                  [
                    320,
                    50
                  ]
                ],
                "name": "efe_topics_bottom_728"
              }
            ]
          }
        }
      }
    }
  ]
};
